module.exports = __webpack_public_path__ + "img/album20_03.5125fcf2.jpg";